import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { history } from '../../../store/configureStore';
import * as appointmentActions from '../../../actions/appointmentActions';
import * as constant from '../../../constants/constant';
import VideoCall from './App';
import * as url from '../../../tools/config';
import openSocket from 'socket.io-client';
import moment from 'moment';
let environment = process.env.REACT_APP_NODE_ENV ? process.env.REACT_APP_NODE_ENV : 'development'
const socket = openSocket(url.getURLForServer(process.env.REACT_APP_NODE_ENV).SOCKET_URL);
import {
	isIOS,
	isMobileView,
	isSafari
  } from "react-device-detect";

class VideoSection extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			API_KEY: '',
			TOKEN: '',
			SESSION_ID: '',
			openVideoRoom: false,
			sessionDataDis: {},
			newId:''
		}
		this.disConnectCall = this.disConnectCall.bind(this);
		this.hideSigninModal = this.hideSigninModal.bind(this);
	}
	hideSigninModal() {
		this.setState({ openVideoRoom: false })
	}
	disConnectCall(event) {
		let sessionDisconnectData = {}
		let sessionObj = {
			token: event.props.session.token,
			sessionId: event.props.session.sessionId
		}
		let videoCallDisconnect = {
			token: this.state.TOKEN,
			sessionId: this.state.SESSION_ID,
		}
		let userData = JSON.parse(localStorage.getItem('user'))
		this.props.actions.disconnectSessionIdToken(videoCallDisconnect)
		if (this.state.sessionDataDis.sender_id == userData._id) {
      sessionDisconnectData.id = this.state.sessionDataDis.receiver_id;
      sessionDisconnectData.callUser = this.state.sessionDataDis;
		} else {
      sessionDisconnectData.id = this.state.sessionDataDis.sender_id;
      sessionDisconnectData.callUser = this.state.sessionDataDis;

    }


		socket.emit('notify_disconnect', {
			sessionData: sessionDisconnectData.id,
			videoId: this.state.sessionDataDis._id,
      		userType: userData.type,
      		callUser:  sessionDisconnectData.callUser,
			notificationType: 'VIDEO_CALL_DISCONNECT'
		}, function () { alert("here") });
    // socket.emit('disconnect_call', {

    //   callUser:  sessionDisconnectData.callUser,
		// 	notificationType: 'disconnect_call'
    // }, function () { alert("here") });
		event.props.session.disconnect();
		event.props.session.on("sessionDisconnected", function (eventResponse) {
			// window.close();
		console.log('session caller Disconnect',eventResponse);
		})
		if(localStorage.getItem('userType') =='specialist'){

			 this.props.history.push('/specialist/my-appointment');
		//	history.push('/specialist/appointment-consultation/'+this.state.newId);
			// window.close();

		// history.push('/specialist/waiting-room-receiver/'+this.state.sessionDataDis._id+'/'+localStorage.getItem('appointmentId'));
		}else{
			// history.push('/waiting-room-receiver/'+this.state.sessionDataDis._id+'/'+localStorage.getItem('appointmentId'));
			this.props.history.push('/my-appointment');

		}
		// window.close();
	}
	componentWillMount() {
		let videoCall = JSON.parse(localStorage.getItem('videoCall'))
		if (this.props.match.params.videoId) {
			videoCall.videoId = this.props.match.params.videoId;
			this.props.actions.createSessionIdToken(videoCall);		
		}
		// localStorage.setItem('appointmentId', this.props.match.params.appointmentId);
		this.setState({
newId:localStorage.getItem('appointmentId')
		})
		let appointmentObj = {
			appointmentId:this.state.newId
		}
		this.props.actions.getAppointmentDetails(appointmentObj);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.sessionData) {
			this.setState({
				openVideoRoom: true,
				API_KEY: nextProps.sessionData ? nextProps.sessionData.apiKey : '',
				TOKEN: nextProps.sessionData ? nextProps.sessionData.sessionConnect.token : '',
				SESSION_ID: nextProps.sessionData ? nextProps.sessionData.sessionConnect.sessionId : '',
				sessionDataDis: nextProps.sessionData ? nextProps.sessionData.sessionConnect : {}
			})
			var videocallobj ={
				openVideoRoom: true,
				API_KEY: nextProps.sessionData.apiKey,
				TOKEN: nextProps.sessionData.sessionConnect.token,
				SESSION_ID: nextProps.sessionData.sessionConnect.sessionId,
				sessionDataDis: nextProps.sessionData ? nextProps.sessionData : {}
			}
			if(isIOS){
				let token = localStorage.getItem('token');
				let returnUrl = window.location.href;
				console.log('token to be send',token);
				window.open(`medfixvideo://main?API_KEY=${videocallobj.API_KEY}&TOKEN=${videocallobj.TOKEN}&SESSION_ID=${videocallobj.SESSION_ID}&sessionDataDis=${videocallobj.sessionDataDis}&userToken=${token}&returnUrl=${returnUrl}`);
					}
		}
    if(isIOS){
      let token = localStorage.getItem('token');
      let returnUrl = window.location.href;
          console.log('token to be send',token);
          window.open(`medfixvideo://main?API_KEY=${videocallobj.API_KEY}&TOKEN=${videocallobj.TOKEN}&SESSION_ID=${videocallobj.SESSION_ID}&sessionDataDis=${videocallobj.sessionDataDis}&userToken=${token}&returnUrl=${returnUrl}`);
				}
	// if(isMobileView){
	// 	      if(videodata.userType =='patient'){
	// 	localStorage.setItem('consultationOpenFrom','VideoCall')
	// 		window.open(constant.PRODUCTION_CURRENT_URL +'specialist/appointment-consultation/'+videodata.appointmentId ,"_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=1000,left=1000,width=1000,height=1000");
	// }
	// }
	}
	render() {
		const constraints = window.constraints = {
			audio: true,
			video: true
		  };
		  
		  function handleSuccess(stream) {
			const video = document.querySelector('video');
			const videoTracks = stream.getVideoTracks();
			console.log('Got stream with constraints:', constraints);
			console.log(`Using video device: ${videoTracks[0].label}`);
			window.stream = stream; // make variable available to browser console
			video.srcObject = stream;
		  }
		  
		  function handleError(error) {
			if (error.name === 'ConstraintNotSatisfiedError') {
			  let v = constraints.video;
			  errorMsg(`The resolution ${v.width.exact}x${v.height.exact} px is not supported by your device.`);
			} else if (error.name === 'PermissionDeniedError') {
			  errorMsg('Permissions have not been granted to use your camera and ' +
				'microphone, you need to allow the page access to your devices in ' +
				'order for the demo to work.');
			}
			errorMsg(`getUserMedia error: ${error.name}`, error);
		  }
		  
		  function errorMsg( error) {
			// const errorElement = document.querySelector('#errorMsg');
			// errorElement.innerHTML += `<p>${msg}</p>`;
			if (typeof error !== 'undefined') {
			  console.error(error);
			}
		  }
			try {
			  const stream = navigator.mediaDevices.getUserMedia(constraints);
			  handleSuccess(stream);
			} catch (e) {
			  handleError(e);
			}
    var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		let image = this.state.image;
		var userType = localStorage.getItem('userType');
		if (user.image == constant.DEFAULT_USER_IMAGE) {
      if (user.gender == 'Male') {
        imagePath =  constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER  + constant.COMMON_FOLDER + 'doctor_m.png'
    }
    else{
      imagePath =  constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER  + constant.COMMON_FOLDER + 'doctor_f.png'
    }
			// var imagePath = constant.PRODUCTION_IMAGE_URL + constant.COMMON_FOLDER + user.image;
		} else {
			var imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
		}
		return (
      <div>
{userType== 'specialist'?
<header className="main-header">
				<Link to={ "/specialist/my-appointment"} className="logo">						<span className="logo-mini"><img src={require('../../../images/img/logo_er_ms.png')} alt="" /></span>
						<span className="logo-lg"><img src={require('../../../images/img/logo_er.png')} alt="" /></span> </Link>
					<nav className="navbar navbar-static-top" role="navigation">
						<Link href="#" className="sidebar-toggle" data-toggle="push-menu" role="button" onClick={this.toggle}> <img src={require('../../../images/img/menu_list.svg')} alt="" /> <span className="sr-only">Toggle navigation</span> </Link>
						<div className="navbar-custom-menu">
							<ul className="nav navbar-nav">
								<li onClick={this.onLogoutclick} className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>

									<Link href="#" className="dropdown-toggle" data-toggle="dropdown">
										<img src={imagePath} className="user-image" alt="User Image" onError={(e) => { e.target.src = defaultImagePath }} />
										<span className="hidden-xs name-capitalize">{user.firstName ? user.firstName : ''} {user.lastName ? user.lastName : ''}</span> </Link>
									<ul className={this.state.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

										<li className="user-setting">	<Link to={{ pathname: "/specialist/my-settings", state: 1 }}>

											<img
												src={require('../../../images/Slicing/Settings-profile.png')}
												className="user-image"
												alt="User Image"
												onError={e => {
													e.target.src = defaultImagePath;
												}}
											/>
											<span>Settings</span>
										</Link></li>
										<li
											className="user-footer passwordLink"
										// style={{ textAlign: "center" }}
										>

											<Link

												className="uploadLink"
												onClick={this._logout}
											>
												<img
													src={require('../../../images/Slicing/logout-profile.png')}
													className="user-image"
													alt="User Image"
													onError={e => {
														e.target.src = defaultImagePath;
													}}
												/>
												<span>	Sign out</span>
											</Link>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</nav>
				</header>
  :''
}
			<div className="content-wrapper">
				<section className="content container-fluid">

					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li ><Link href="#tab_1" data-toggle="tab" className="active show">Video Call</Link></li>
									</ul>


									<div className="tab-content">
										<div className="tab-pane active" id="tab_1">

											<div className="settingInput settingV">
												{this.state.openVideoRoom ? <VideoCall
													apiKey={this.state.API_KEY}
													sessionId={this.state.SESSION_ID}
													token={this.state.TOKEN}
													opentokClientUrl="https://static.opentok.com/v2/js/opentok.min.js"
													disConnectCall={this.disConnectCall}
													openVideoRoom={this.state.openVideoRoom}
													hideSigninModal={this.hideSigninModal}
													loadingDelegate={<div>Loading...</div>}

												/> : ''}



											</div>


										</div>
									</div>


								</div>
							</div>
						</div>
					</div>
				</section>
      </div>
      </div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		sessionData: state.appointment.sessionData,
		// appointmentDetails: state.appointment.appointmentDetails
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(appointmentActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(VideoSection);
